import React from 'react'
import { BasketTypes } from 'types'
import { STORAGE_KEYS } from 'src/constants'
import { Gtm } from 'helpers'

interface State {
    basket: BasketTypes.Item[]
}

const defaultState = {
    basket: []
}

export const ShopContext = React.createContext(defaultState)

export default class ShopStore extends React.Component<Object, State> {

    public state = defaultState

    public componentDidMount () {
        this.loadBasket()
    }

    public loadBasket() {
        const cashedBasket: any = localStorage.getItem(STORAGE_KEYS.BASKET_ITEMS)
        if (cashedBasket) {
            this.setState({
                basket: JSON.parse(cashedBasket)
            })
        }
    }

    public addToBasket = (item: BasketTypes.Item) => {

        const itemIndex = this.state.basket
            .findIndex((value: BasketTypes.Item) => value.id === item.id && value.week === item.week)

        let updatedBasket: BasketTypes.Item[] = this.state.basket
        if (itemIndex > -1) {
            updatedBasket[itemIndex].quantity = item.quantity
        } else {
            updatedBasket = [...this.state.basket , item ]
        }

        this.setState(state => ({
            basket: updatedBasket
        }))

        // Add to localStorage
        this.synclocalStorage(updatedBasket)

        // GTM
        Gtm.pushFlowEvent('addToCart', {
            add: {
                products: [{
                    name: `${item.productGroupName} - ${item.name}`,
                    id: item.articleId,
                    brand: 'New Surplus Order',
                    variant: item.formId,
                    quantity: item.quantity
                }]
            }
        })
        // End GTM
    }

    public removeFromBasket = (item: BasketTypes.Item) => {
        const filteredBasket = this.state.basket
            .filter((value: BasketTypes.Item) => value !== item)

        this.setState(state => ({
            basket: filteredBasket
        }))
        // Add to localStorage
        this.synclocalStorage(filteredBasket)

        // GTM
        Gtm.pushFlowEvent('removeFromCart', {
            remove: {
                products: [{
                    name: `${item.productGroupName} - ${item.name}`,
                    id: item.articleId,
                    brand: 'New Surplus Order',
                    variant: item.formId,
                    quantity: item.quantity
                }]
            }
        })
        // End GTM
    }

    public synclocalStorage = (data: BasketTypes.Item[]) => {
        localStorage.setItem(STORAGE_KEYS.BASKET_ITEMS, JSON.stringify(data))
    }

    public clearBasket = () => {
       this.setState({
           basket: []
       })
       localStorage.removeItem(STORAGE_KEYS.CLIENT)
       localStorage.removeItem(STORAGE_KEYS.BASKET_ITEMS)
    }

    public render() {

        const valueData = {
            basket: this.state.basket,
            addToBasket: this.addToBasket,
            removeFromBasket: this.removeFromBasket,
            clearBasket: this.clearBasket
        }

        return (
            <ShopContext.Provider value={valueData}>
                {this.props.children}
            </ShopContext.Provider>
        )
    }
}



// WEBPACK FOOTER //
// ./src/stores/ShopStore.tsx